export default __webpack_public_path__ + "static/media/Modelo-de-Contrato-de-Associação.603a9195.docx";